import Mock from 'mockjs'
// import passportApi from './passport'
// import opeartorApi from './operator'
// import withdrawApi from './withdraw'
// import shopApi from './shop'
// import orderApi from './order'
// import tradeApi from './trade'
/** *****************************首页部分**************************************/
// 退出登录
// Mock.mock(/\/saas\/passport.logout/, 'post', passportApi.logout)
// // 登录
// Mock.mock(/\/saas\/passport.login/, 'post', passportApi.login)
// // 发送短信验证码
// Mock.mock(/\/saas\/passport.verifysms/, 'post', passportApi.sendSmsCode)
// // 获取图形验证码
// Mock.mock(/\/saas\/passport.verifyimage/, 'get', passportApi.getImgCode)

// // 获取操作员信息
// Mock.mock(/\/shop\/account.info/, 'post', opeartorApi.getOperator)

// // 获取支付列表
// Mock.mock(/\/admin\/withdraw.query/, 'post', withdrawApi.getList)

// // 获取店铺列表
// Mock.mock(/\/admin\/chain.query/, 'post', shopApi.getShopList)

// // 获取订单列表
// Mock.mock(/\/admin\/rentorder.query/, 'post', orderApi.getOrderList)

// // 账号查询
// Mock.mock(/\/admin\/account.query/, 'post', opeartorApi.getOperatorList)

// // 账号启用
// Mock.mock(/\/admin\/account.enable/, 'post', opeartorApi.operatorEnable)

// // 账号禁用
// Mock.mock(/\/admin\/account.disable/, 'post', opeartorApi.operatorEnable)

// // 账号模拟登录
// Mock.mock(/\/admin\/account.simulatelogin/, 'post', opeartorApi.simulatelogin)

// // 在线收支查询
// Mock.mock(/\/admin\/onlinepayment.query/, 'post', tradeApi.getOnlinePaymentList)

// // 在线收支导出
// Mock.mock(/\/admin\/onlinepayment.export/, 'post', tradeApi.onlinePaymentExport)
export default Mock



// WEBPACK FOOTER //
// ./src/mock/index.js